const initialState = {
  mainActivities: [],
  loading: false,
  error: null,
};
export const selectActivityNameById = (state, id) => {
  const activities = state.activity?.mainActivities || [];
  const activity = activities.find(a => String(a.id) === String(id));
  return activity?.name || '';
};


export default function activityReducer(state = initialState, action) {
  switch (action.type) {
    case 'FETCH_ACTIVITIES_REQUEST':
      return { ...state, loading: true, error: null };

    case 'FETCH_ACTIVITIES_SUCCESS':
      return { ...state, loading: false, mainActivities: action.payload };

    case 'FETCH_ACTIVITIES_FAILURE':
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
}
